import * as React from 'react';
import { Button, Tooltip } from '@wix/design-system';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import s from './ProductButton.scss';

type ProductButtonSize = 'small' | 'medium';
interface ProductButtonProps {
  text: string;
  onClick: () => void;
  size?: ProductButtonSize;
  fullColor?: boolean;
  disabled?: boolean;
  dataHook?: string;
  fullWidth?: boolean;
}

export function ProductButton({
  text,
  onClick,
  size = 'medium',
  fullColor,
  disabled,
  dataHook,
  fullWidth = true,
}: ProductButtonProps) {
  const { t } = useTranslation();
  const getButtonPriority = () => {
    if (disabled) {
      return 'secondary';
    }
    return fullColor ? 'primary' : 'secondary';
  };
  const priority = getButtonPriority();

  return (
    <Tooltip
      placement='bottom'
      content={t(
        'Advanced.Plans_second.upgrade_plan.disabled.tooltip',
        'Disabled',
      )}
      className={s.cardsButtonTooltip}
      disabled={!disabled}
    >
      <Button
        className={classNames({
          [s.minimized]: size === 'small',
          [s.studioPrimary]: priority === 'primary' && !disabled,
          [s.studioSecondary]: priority === 'secondary' && !disabled,
        })}
        fullWidth={fullWidth}
        onClick={onClick}
        priority={priority}
        disabled={disabled}
        dataHook={dataHook}
        skin='standard'
        size={size}
      >
        {text}
      </Button>
    </Tooltip>
  );
}
